import React, { useEffect, useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import { LanguageContext } from '../../contexts/LanguageContext';
import { 
  StyledDifferentials, 
  DifferentialsGrid, 
  DifferentialCard,
  TechCircuit
} from './styles';

const Differentials = () => {
  const { theme } = useContext(ThemeContext);
  const { language, translations } = useContext(LanguageContext);

  const differentials = [
    {
      icon: 'fas fa-laptop-code',
      title: 'differential1Title',
      description:  'differential1Desc'
    },
    {
      icon: 'fas fa-exchange-alt',
      title: 'differential2Title',
      description:  'differential2Desc'
    },
    {
      icon: 'fas fa-users',
      title: 'differential3Title',
      description:  'differential3Desc'
    }
  ];

  // Adicionar efeito de circuito tecnológico animado
  useEffect(() => {
    const techCircuit = document.querySelector('.tech-circuit');

    const handleScroll = () => {
      if (!techCircuit) return;
      const scrollPosition = window.scrollY;
      const offset = scrollPosition * 0.1;
      techCircuit.style.backgroundPosition = `${offset}px ${offset}px`;
    };

    if (techCircuit) {
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <StyledDifferentials id="diferenciais">
      <div className="container">
        <h2 dangerouslySetInnerHTML={{ __html: translations[language].differentialsTitle }} />
        <DifferentialsGrid>
          {differentials.map((differential, index) => (
            <DifferentialCard 
              key={index} 
              data-aos="zoom-in" 
               data-aos-delay={index * 50}
            >
              <div className="icon">
                <i className={differential.icon}></i>
              </div>
              <h3>{translations[language][differential.title]}</h3>
              <p>{translations[language][differential.description]}</p>
            </DifferentialCard>
          ))}
        </DifferentialsGrid>
      </div>
      <TechCircuit className="tech-circuit" />
    </StyledDifferentials>
  );
};

export default Differentials;
